'use es6';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ExpandedLessonNavigatorLesson from '../../../components/Navigator/LessonNavigator/ExpandedLessonNavigatorLesson';
import { getTrackByIdIsLoading } from '../../../selectors/trackSelectors';
import { getLesson } from '../../../selectors/lessonSelectors';

function mapStateToProps(state, ownProps) {
  const {
    contentById
  } = state;
  const {
    urlPrefix = 'lessons',
    includeCompleteIcon = true,
    currentContentId,
    match: {
      params: {
        lessonId,
        contentId
      } = {}
    }
  } = ownProps;
  const {
    lesson = getLesson(state, {
      lessonId
    })
  } = ownProps;
  const tracksAreRequesting = getTrackByIdIsLoading(state);
  const orderedContent = lesson.get('contentIds').map(id => contentById.get(id)).filter(content => !tracksAreRequesting && content);
  return {
    lesson,
    content: orderedContent,
    currentContentId: currentContentId || contentId,
    includeCompleteIcon,
    urlPrefix
  };
}

const LessonNavigatorContainer = withRouter(connect(mapStateToProps)(ExpandedLessonNavigatorLesson));
export default LessonNavigatorContainer;